/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import lang from 'quasar/lang/en-US.js'

import {Cookies,Dialog,Loading,Meta,Notify} from 'quasar'

export default { config: {"notify":{"position":"bottom-right","timeout":10000,"actions":[{"label":"Close","noCaps":true,"color":"primary","icon":"ti-x"}]},"loading":{"delay":400},"ripple":{"color":"primary"}},lang,plugins: {Cookies,Dialog,Loading,Meta,Notify} }
